export function canAccessStatements(userInfo) {
  return userInfo.isUS || userInfo.isCA || userInfo.isGB;
}